import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, Transition as _Transition, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container max-w-xl relative mx-auto" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("Home")
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" | ")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Create")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_UiToggleTheme = _resolveComponent("UiToggleTheme")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _createElementVNode("nav", null, [
      _createVNode(_component_router_link, {
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.setSlideType('left'))),
        to: "/"
      }, {
        default: _withCtx(() => [
          _hoisted_2
        ]),
        _: 1
      }),
      _hoisted_3,
      _createVNode(_component_router_link, {
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.setSlideType('right'))),
        to: "/create"
      }, {
        default: _withCtx(() => [
          _hoisted_4
        ]),
        _: 1
      }),
      _createVNode(_component_UiToggleTheme, {
        onClick: _ctx.toggleTheme,
        isdark: _ctx.theme === 'dark'
      }, null, 8, ["onClick", "isdark"])
    ]),
    _createVNode(_component_router_view, null, {
      default: _withCtx(({ Component }) => [
        _createVNode(_Transition, {
          name: _ctx.slideType,
          mode: "out-in"
        }, {
          default: _withCtx(() => [
            (_openBlock(), _createBlock(_resolveDynamicComponent(Component), {
              key: _ctx.$route.path
            }))
          ]),
          _: 2
        }, 1032, ["name"])
      ]),
      _: 1
    })
  ]))
}